import React from "react";
import { node, string } from "prop-types";
import classNamesMaker from "classnames";
import styles from "./CellInformation.module.css";
export var CellInformation = function CellInformation(props) {
  var children = props.children,
    className = props.className;
  var customClassNames = classNamesMaker(styles["jds-CellInformation"], className);
  return /*#__PURE__*/React.createElement("div", {
    className: customClassNames
  }, children);
};
CellInformation.propTypes = {
  children: node.isRequired,
  className: string
};
CellInformation.defaultProps = {
  className: null
};